import { render } from "./StrategiesChatbot.vue?vue&type=template&id=4835b3b4"
import script from "./StrategiesChatbot.vue?vue&type=script&lang=js"
export * from "./StrategiesChatbot.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__